import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

/**
 * Modal for loading existing configurations
 */
const LoadConfigModal = ({ open, onClose, onLoad, modalState, onStateChange }) => {
  const { loading, error, results, selectedConfigId } = modalState;

  const handleLoad = () => {
    if (selectedConfigId) {
      onLoad(selectedConfigId);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Load Existing Configuration</DialogTitle>
      <DialogContent>
        {loading && (
          <Typography sx={{ mb: 2, textAlign: "center" }}>Loading configurations...</Typography>
        )}

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        {!loading && !error && results.length > 0 && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="config-select-label">Select Configuration</InputLabel>
            <Select
              labelId="config-select-label"
              id="config-select"
              value={selectedConfigId}
              label="Select Configuration"
              onChange={(e) => onStateChange("selectedConfigId", e.target.value)}
            >
              {results.map((config) => (
                <MenuItem key={config.id} value={config.id}>
                  {config.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {!loading && !error && results.length === 0 && open && (
          <Typography color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
            No configurations found. Create a new configuration to get started.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {selectedConfigId && (
          <Button onClick={handleLoad} variant="contained" disabled={loading}>
            Load Configuration
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default LoadConfigModal;
